import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { fileQueryKeys } from "./fileQueryKeys";

export function useFileMetadata(
  fileId: string,
  options?: { isEnabled?: boolean },
) {
  const { files: fileService } = useDomainServices();
  const { isEnabled = true } = options || {};

  return useQuery<Record<string, unknown>, Error>({
    queryKey: fileQueryKeys.metadata(fileId),
    queryFn: async ({ signal }) => {
      if (fileId === undefined) {
        return Promise.reject(new Error("Invalid fileId"));
      }

      const fileRecord = await fileService.getFileRecord(fileId, {
        abortSignal: signal,
      });

      return fileRecord.metadata;
    },
    enabled: isEnabled,
    staleTime: 60000,
  });
}
